<template>
  <div class="container">
    <menuAdmin />
    <FullScreenLoader v-if="loading" />

    <div v-else>
      <div class="card mb-4">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <h5 class="card-title mb-0">Pre LiveShop</h5>
            </div>
            <div class="col-md-3 text-right">
              <div class="custom-control custom-switch" @click="updateActive(1)">
                <input type="checkbox" class="custom-control-input" :checked="active == 1" />
                <label class="custom-control-label" :class="{ opacity: active != 1 }">Activar</label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="titulo">Título del LiveShop</label>
                <input type="titulo" class="form-control" id="titulo" placeholder="Nombre del LiveShop" required
                  v-model="title" />
                <button type="submit" class="btn btn-primary submit" @click="updateTitle()"
                  :disabled="title.length == 0">
                  Guardar
                </button>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="descripcion">Descripción</label>
                <input type="text" class="form-control" id="descripcion" placeholder="Descripcion" required
                  v-model="description" />
                <button type="submit" class="btn btn-primary submit" @click="updateDescription()"
                  :disabled="description.length == 0">
                  Guardar
                </button>
              </div>
            </div>
            <div class="col-md-9 mb-4">
              <label class="control-label">Fecha del evento (contador)</label>
              <input type="datetime-local" class="form-control" id="fecha" placeholder="ingresa la fecha" required
                v-model="fecha" />
              <button type="submit" class="btn btn-primary submit" @click="updateFecha()">
                Guardar
              </button>
            </div>

            <div class="col">
              <label class="control-label">Imagenes PreLive</label>
              <div class="custom-images">
                <div class="box-img-pc">
                  <div class="tag">PC</div>
                  <input type="file" id="pre_pc" lang="es" @change="updateImagen('pre_pc')">
                  <img class="img-pc" :src="urlImgPrePC">
                </div>
                <div class="box-img-mo">
                  <div class="tag">Mobile</div>
                  <input type="file" id="pre_mo" lang="es" @change="updateImagen('pre_mo')">
                  <img class="img-mo" :src="urlImgPreMO">
                </div>
              </div>
            </div>
            <!-- <div class="col-12 mt-4">
              <div class="custom-control custom-switch" @click="updateItemCheckbox('footer')">
                <input type="checkbox" class="custom-control-input" :checked="footer" />
                <label class="custom-control-label" :class="{ opacity: footer == false }">Mostrar Footer</label>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <h5 class="card-title mb-0">Post LiveShop</h5>
            </div>
            <div class="col-md-3 text-right">
              <div class="custom-control custom-switch" @click="updateActive(2)">
                <input type="checkbox" class="custom-control-input" :checked="active == 2" />
                <label class="custom-control-label" :class="{ opacity: active != 2 }">Activar</label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="control-label">Imagenes PostLive</label>
              <div class="custom-images">
                <div class="box-img-pc">
                  <div class="tag">PC</div>
                  <input type="file" id="post_pc" lang="es" @change="updateImagen('post_pc')">
                  <img class="img-pc" :src="urlImgPostPC">
                </div>
                <div class="box-img-mo">
                  <div class="tag">Mobile</div>
                  <input type="file" id="post_mo" lang="es" @change="updateImagen('post_mo')">
                  <img class="img-mo" :src="urlImgPostMO">
                </div>
              </div>
              <div class="form-group">
                <label for="url_replay">Codigo YouTube</label>
                <input type="url_replay" class="form-control" id="url_replay" placeholder="Url Video"
                  v-model="urlReplay" />
                <button type="submit" class="btn btn-primary submit" @click="updateUrlReplay()">
                  Guardar
                </button>
              </div>
              <!-- <div class="custom-control custom-switch" @click="updateItemCheckbox('footer')">
                <input type="checkbox" class="custom-control-input" :checked="footer" />
                <label class="custom-control-label" :class="{ opacity: footer == false }">Mostrar Footer</label>
              </div> -->
            </div>
          </div>
        </div>

      </div>

      <div class="card mb-4">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <h5 class="card-title mb-0">LiveShop - Transmisión en vivo</h5>
            </div>
            <div class="col-md-3 text-right">
              <div class="custom-control custom-switch" @click="updateActive(3)">
                <input type="checkbox" class="custom-control-input" :checked="active == 3" />
                <label class="custom-control-label" :class="{ opacity: active != 3 }">Activar</label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label class="control-label">Horario Fin de Ofertas</label>
              <input type="datetime-local" class="form-control" id="fecha" placeholder="ingresa la fecha" required
                v-model="fechaOfertas" />
              <button type="submit" class="btn btn-primary submit" @click="updateFechaOfertas()">
                Guardar
              </button>

            </div>
            <div class="col-md-9 mt-1">
              <div class="form-group">
                <label for="video">ID Video Youtube</label>
                <div class="input-group">
                  <input type="url" class="form-control" id="video" placeholder="debes ingresar una url" required
                    v-model="videoUrl" />
                  <div class="tool-tip-container">
                    <ToolTip :icon="'?'"
                      :infoText="`Ingresa el codigo destacado de la url https://www.youtube.com/watch?v=<strong>PSvfNJbrjjk</strong>`" />
                  </div>
                </div>
                <button type="submit" class="btn btn-primary submit" @click="updateVideo()"
                  :disabled="videoUrl.length == 0">
                  Guardar
                </button>
              </div>
            </div>
            <div class="col">
              <div>
                <div class="custom-control custom-switch" @click="updateItemCheckbox('lateralHide')">
                  <input type="checkbox" id="lateralHide" class="custom-control-input" :checked="lateralHide" />
                  <label class="custom-control-label" :class="{ opacity: !lateralHide }">Ocultar Ofertas y
                    Chat</label>
                </div>
              </div>

              <div>
                <div class="custom-control custom-switch" @click="updateItemCheckbox('offersHide')">
                  <input type="checkbox" id="offersHide" class="custom-control-input" :checked="!offersHide" />
                  <label class="custom-control-label" :class="{ opacity: offersHide }">Mostrar Ofertas</label>
                </div>
              </div>
              <div>
                <div class="custom-control custom-switch" @click="updateItemCheckbox('chat')">
                  <input type="checkbox" id="chat" class="custom-control-input" :checked="chat" />
                  <label class="custom-control-label" :class="{ opacity: !chat }">Mostrar Chat</label>
                </div>
              </div>
              <div>
                <div class="custom-control custom-switch" @click="updateItemCheckbox('likes')">
                  <input type="checkbox" id="likes" class="custom-control-input" :checked="likes" />
                  <label class="custom-control-label" :class="{ opacity: !likes }">Habilitar Likes</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import fire from "./../fire";
import menuAdmin from "../components/MenuAdmin";
import draggable from "vuedraggable";
import ToolTip from "../components/ToolTip.vue";
import FullScreenLoader from "../components/FullScreenLoader.vue";

export default {
  name: "AdminConfig",
  components: { menuAdmin, draggable, ToolTip, FullScreenLoader },
  // eslint-disable-next-line vue/no-unused-components
  data() {
    return {
      messages: [],
      loading: true,
      chat: false,
      suscripcion: false,
      verVideo: false,
      videoUrl: "",
      videoMobile: "",
      title: "",
      fecha: "",
      fechaOfertas: "",
      contador: false,
      bannerContador: false,
      likes: false,
      active: '',
      footer: '',
      description: '',
      list: [
        { name: "Slider Tips de compra", status: false, id: 0, type: 'boolean', value: false },
        { name: "Slider programas anteriores", status: true, id: 1, type: 'boolean', value: true },
        { name: "HTML Personalizado", status: false, id: 2, type: 'html', value: '<p>Párrafo</p>' }
      ],
      listPrelive: [],
      preliveHTML: '',
      dragging: false,
      urlImgPostPC: '',
      urlImgPostMO: '',
      urlImgPrePC: '',
      urlImgPreMO: '',
      urlReplay: '',
      lateralHide: false,
      offersHide: false,
    };
  },
  methods: {
    updateActive(id) {
      this.active = id
      fire
        .database()
        .ref("config")
        .update(
          {
            active: this.active
          },
          function (error) {
            if (error) {
              console.log("The write failed");
            } else {
              console.log("Data saved successfully!");
            }
          }
        );
    },
    getListPrelive() {
      let list = [
        { name: "Slider Tips de compra", status: false, type: 'boolean', value: false },
        { name: "Slider programas anteriores", status: true, type: 'boolean', value: true },
        { name: "HTML Personalizado", status: false, type: 'html', value: this.preliveHTML }
      ]
      //this.listPrelive = list
    },

    updateItemCheckbox(item) {
      //Select the Item checkbox
      let checkBox = document.getElementById(item);
      //Set the value to the opposite
      let newValue = !this[item];
      // Set the value in Vue Local data to see the change in the front
      this[item] = newValue;
      //Firebase update in dB
      fire
        .database()
        .ref("config")
        .update(
          {
            [item]: newValue
          },
          (error) => {
            if (error) {
              console.log("The write failed");
            } else {
              console.log(`Valor del ${item}: ${newValue} guardado`);
            }
          }
        );
    },

    updateVideo() {
      if (this.videoUrl.length > 0) {
        fire
          .database()
          .ref("config")
          .update(
            {
              video: this.videoUrl
            },
            function (error) {
              if (error) {
                console.log("The write failed");
              } else {
                console.log("Data saved successfully!");
                alert("Guardado");
              }
            }
          );
      }
    },
    updateTitle() {
      if (this.title.length > 0) {
        fire
          .database()
          .ref("config")
          .update(
            {
              titulo: this.title
            },
            function (error) {
              if (error) {
                console.log("The write failed");
              } else {
                console.log("Data saved successfully!");
                alert("Guardado");
              }
            }
          );
      }
    },
    updateDescription() {
      if (this.description.length > 0) {
        fire
          .database()
          .ref("config")
          .update(
            {
              description: this.description
            },
            function (error) {
              if (error) {
                console.log("The write failed");
              } else {
                console.log("Data saved successfully!");
                alert("Guardado");
              }
            }
          );
      }
    },
    updateFecha() {
      if (this.fecha.length > 0) {
        fire
          .database()
          .ref("config")
          .update(
            {
              fecha: this.fecha
            },
            function (error) {
              if (error) {
                console.log("The write failed");
              } else {
                console.log("Data saved successfully!");
              }
            }
          );
      }
    },
    updateFechaOfertas() {
      if (this.fecha.length > 0) {
        fire
          .database()
          .ref("config")
          .update(
            {
              fechaOfertas: this.fechaOfertas
            },
            function (error) {
              if (error) {
                console.log("The write failed");
              } else {
                console.log("Data saved successfully!");
              }
            }
          );
      }
    },
    updateImagen(image) {
      console.log("Cambio: " + image)

      const ref = fire.storage().ref();
      const file = document.querySelector("#" + image).files[0];
      if (file) {
        const name = +new Date() + "-" + file.name;
        const metadata = {
          contentType: file.type
        };
        const task = ref.child(name).put(file, metadata);
        task
          .then(snapshot => snapshot.ref.getDownloadURL())
          .then(url => {
            console.log(url);

            let dataUpdate = {};
            switch (image) {
              case 'post_pc':
                dataUpdate = {
                  urlImgPostPC: url
                }
                break;
              case 'post_mo':
                dataUpdate = {
                  urlImgPostMO: url
                }
                break;
              case 'pre_pc':
                dataUpdate = {
                  urlImgPrePC: url
                }
                break;
              case 'pre_mo':
                dataUpdate = {
                  urlImgPreMO: url
                }
                break;
              default:
                break;
            }
            fire
              .database()
              .ref("config")
              .update(
                dataUpdate,
                function (error) {
                  if (error) {
                    console.log("Error al guardar");
                  } else {
                    alert("Imagen guardada correctamente!");
                  }
                }
              );
          })
          .catch(console.error);
      } else {
        alert('Debes subir un archivo')
      }
    },
    updateUrlReplay() {
      fire
        .database()
        .ref("config")
        .update(
          {
            urlReplay: this.urlReplay
          },
          function (error) {
            if (error) {
              console.log("The write failed");
            } else {
              console.log("Data saved successfully!");
              alert("Guardado");
            }
          }
        );
    },
  },
  mounted() {
    this.getListPrelive();
    let ref = this;
    const itemsRef = fire.database().ref("config");
    console.log(itemsRef);
    itemsRef.on("value", snapshot => {
      ref.loading = false;
      let data = snapshot.val();
      if (data.chat === true) {
        ref.chat = true;
      } else {
        ref.chat = false;
      }

      if (data.verVideo === true) {
        ref.verVideo = true;
      } else {
        ref.verVideo = false;
      }

      ref.videoUrl = data.video;
      ref.videoMobile = data.videoMobile;
      ref.title = data.titulo;
      ref.contador = data.contador;
      ref.bannerContador = data.bannerContador;
      ref.suscripcion = data.suscripcion;
      ref.likes = data.likes;
      ref.active = data.active;
      ref.description = data.description;
      ref.urlImgPostPC = data.urlImgPostPC;
      ref.urlImgPostMO = data.urlImgPostMO;
      ref.urlImgPrePC = data.urlImgPrePC;
      ref.urlImgPreMO = data.urlImgPreMO;
      ref.urlReplay = data.urlReplay;
      ref.offersHide = data.offersHide;
      ref.lateralHide = data.lateralHide;

      let output = Object.entries(data.preLive).map(([key, value]) => ({ key, value }));

      ref.listPrelive = output;

      if (data.fecha) {
        ref.fecha = data.fecha;
      }
      if (data.fechaOfertas) {
        ref.fechaOfertas = data.fechaOfertas;
      }
    });
  }
};
</script>

<style lang="scss">
.submit {
  margin-top: 10px;
}

.handle {
  padding-top: 8px;
  padding-bottom: 8px;
  cursor: move;
}

.close {
  float: right;
  padding: 10px;
}

.sortable-chosen {
  background-color: #e6f2ff !important;
}

.sortable-ghost {
  margin-left: 20px !important;
  opacity: 0.8 !important;
}

.custom-images {
  position: relative;
  display: flex;
  margin-bottom: 20px;

  .box-img-pc,
  .box-img-mo {
    position: relative;
    width: 192px;
    height: 108px;
    background-color: #000;
    margin-right: 20px;
    overflow: hidden;

    .tag {
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: #000;
      color: #FFF;
      font-weight: 600;
      padding: 4px 8px;
      z-index: 3;
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 2;
    }

    img.img-pc {
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      width: 100%;
      height: auto;
      z-index: 1;
    }

    img.img-mo {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: auto;
      height: 100%;
      z-index: 1;
    }
  }
}
</style>
